import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import Handlebars from '@sparta.global.vendors/handlebars';
import { button } from '@sparta.global.helpers/button-helper/dist/es5.js';
var mobileTypeObjectKey = 'mobile';
var androidTypeObjectKey = 'android';
var defaultTypeObjectKey = 'default';
var localSpaParams;
var InputConfig = /*#__PURE__*/_createClass(function InputConfig(options) {
  _classCallCheck(this, InputConfig);
  var attrs = Object.assign({}, defaultAttributes, options);
  this.input = {
    attrs: attrs
  };
});
/**
 * @method checkForRequiredAttributes
 * @description makes sure the element's attributes contain all required attributes
 * @param {Object} attributes object of attributes to be applied to element
 * @param {Array} required array of attributes that must be present
 * @returns Boolean
 */
function checkForRequiredAttributes(attributes, required) {
  return required.every(function (key) {
    return attributes.hasOwnProperty(key);
  });
}
function parseViewportDependentAttribute(attribute) {
  var defaultAttr = '';
  var mobileAttr = '';
  var androidAttr = '';
  if (typeof attribute === 'string') {
    defaultAttr = attribute;
    mobileAttr = attribute;
    androidAttr = attribute;
  } else {
    if (typeof attribute[mobileTypeObjectKey] !== 'undefined') {
      mobileAttr = attribute[mobileTypeObjectKey];
    }
    if (typeof attribute[androidTypeObjectKey] !== 'undefined') {
      androidAttr = attribute[androidTypeObjectKey];
    }
    if (typeof attribute[defaultTypeObjectKey] !== 'undefined') {
      defaultAttr = attribute[defaultTypeObjectKey];
    }
  }
  return {
    defaultAttr: defaultAttr,
    mobileAttr: mobileAttr,
    androidAttr: androidAttr
  };
}

/**
 * @method formatTextInput
 * @description builds Handlebars string for input markup based on parameters
 * @param {Object} inputData object containing parameters for this input
 * @param {String} defaultInputAttributes input attributes to use by default
 * @returns Handlebars.SafeString
 */
function formatTextInput(data, defaultInputAttributes) {
  var requiredAttrs = ['id'];
  var combinableAttrs = ['class', 'value'];
  var defaultAttrs = JSON.parse(JSON.stringify(defaultInputAttributes));
  var inputData = JSON.parse(JSON.stringify(data));
  var applyGISMask = inputData.input['gis-mask'];
  var applyDatepicker = inputData.input.datepicker;
  if (typeof applyGISMask !== 'undefined') {
    defaultAttrs.input.attrs.class += ' gis-mask';
    inputData.input.attrs['data-field-type'] = applyGISMask;
  }
  if (typeof applyDatepicker !== 'undefined' && applyDatepicker) {
    defaultAttrs.input.attrs.class += ' datepicker';
  }
  combinableAttrs.forEach(function (attr) {
    if (typeof defaultAttrs.input.attrs[attr] !== 'undefined' && typeof inputData.input.attrs[attr] !== 'undefined') {
      if (typeof inputData.input.attrs[attr] !== 'undefined' && attr === 'value') {
        inputData.input.attrs[attr] = "".concat(inputData.input.attrs[attr]).concat(defaultAttrs.input.attrs[attr]);
      } else if (inputData.input.attrs[attr]) {
        inputData.input.attrs[attr] = "".concat(inputData.input.attrs[attr], " ").concat(defaultAttrs.input.attrs[attr]);
      }
    }
  });
  var maskOptions = Object.assign({}, inputData.input.attrs['data-sparta-input-mask']);
  var maskDefaults = Object.assign({}, defaultAttrs.input.attrs['data-sparta-input-mask']);
  var mask = Object.assign({}, maskDefaults, maskOptions);
  var inputAttributes = Object.assign({}, defaultAttrs.input.attrs, inputData.input.attrs, {
    'data-sparta-input-mask': mask
  });
  var reservedAttrs = ['type', 'pattern', 'data-help-link', 'data-help-head', 'data-help-body'];
  var format = inputData.input.format;
  var validationRules = inputData.validationRules;
  var attrsStr = [];
  var helpToggle = inputData.helpToggle ? inputData.helpToggle : inputData.label.text;
  if (!checkForRequiredAttributes(inputData.input.attrs, requiredAttrs)) {
    throw new Error("You are missing one of the following required attributes:  ".concat(requiredAttrs.join(', ')));
  }
  var defaultFormatAttributes = {};
  if (format) {
    defaultFormatAttributes['data-sparta-input-format'] = format;
  }
  var formatAttributes = {
    name: {
      autocorrect: 'off'
    },
    phone: {
      autocomplete: 'tel',
      autocorrect: 'off',
      'data-sparta-input-mask': {
        alias: 'phone',
        mask: '999-999-9999',
        jitMasking: false,
        greedy: true,
        placeholder: '_'
      }
    },
    'phone-extended': {
      autocomplete: 'tel',
      autocorrect: 'off',
      'data-sparta-input-mask': {
        alias: 'phone',
        mask: '999-999-9999[ x9{1,4}]',
        jitMasking: false,
        greedy: true,
        placeholder: '_'
      }
    },
    email: {
      autocorrect: 'off',
      autocapitalize: 'off',
      autocomplete: 'email'
    },
    'street-address': {
      autocomplete: 'street-address'
    },
    address: {
      autocomplete: 'address-line1'
    },
    'address-2': {
      autocomplete: 'address-line2'
    },
    city: {
      autocomplete: 'address-level2'
    },
    state: {
      autocomplete: 'address-level1'
    },
    zip: {
      autocomplete: 'postal-code',
      pattern: '^\\d{5}$',
      inputmode: 'numeric',
      novalidate: true,
      autocorrect: 'off',
      'data-sparta-input-mask': {
        mask: '99999'
      }
    },
    'zip-extended': {
      type: "text",
      autocomplete: 'postal-code',
      pattern: '^\\d{5}(-\\d{4})?$',
      inputmode: 'numeric',
      novalidate: true,
      autocorrect: 'off',
      'data-sparta-input-mask': {
        mask: '99999[-9999]'
      }
    },
    'cc-number': {
      autocomplete: 'cc-number',
      inputmode: 'numeric',
      pattern: '^\\d{4}(-\\d{4}){3}$',
      novalidate: true,
      autocorrect: 'off',
      'data-sparta-input-mask': {
        mask: '9999 9999 9999 9999'
      }
    },
    'cc-csc': {
      autocomplete: 'cc-csc',
      inputmode: 'numeric',
      pattern: '^\\d{3,4}$',
      novalidate: true,
      autocorrect: 'off',
      'data-sparta-input-mask': {
        mask: '9{3,4}'
      }
    },
    ssn: {
      pattern: '^\\d{3}-\\d{2}-\\d{4}$',
      novalidate: true,
      'data-sparta-input-mask': {
        mask: '999-99-9999',
        jitMasking: false,
        greedy: true,
        placeholder: '_'
      }
    },
    vin: {
      'data-sparta-input-mask': {
        alias: 'vin'
      }
    },
    'external-account': {
      pattern: '[0-9]*',
      novalidate: true,
      'data-sparta-input-mask': {
        alias: 'numeric',
        groupSeparator: '',
        autoGroup: false,
        digits: 0,
        rightAlign: false
      }
    },
    'internal-account': {
      pattern: '[0-9]*',
      novalidate: true,
      'data-sparta-input-mask': {
        alias: 'numeric',
        groupSeparator: '',
        autoGroup: false,
        digits: 0,
        rightAlign: false
      }
    },
    date: {
      inputmode: 'numeric',
      novalidate: true,
      autocorrect: 'off',
      pattern: '^(0[1-9]|1[012])\\/(0[1-9]|[12]\\d|3[01])\\/\\d{4}$',
      'data-sparta-input-mask': {
        alias: 'mm/dd/yyyy',
        jitMasking: true,
        greedy: false,
        placeholder: ''
      }
    },
    number: {
      novalidate: true,
      'data-sparta-input-mask': {
        alias: 'numeric',
        groupSeparator: ',',
        autoGroup: true,
        digitsOptional: true,
        decimalProtect: true,
        rightAlign: false,
        digits: 0,
        placeholder: ''
      }
    },
    currency: {
      novalidate: true,
      'data-sparta-input-mask': {
        alias: 'currency',
        prefix: '',
        allowMinus: true,
        rightAlign: false,
        digitsOptional: true,
        digits: 2
      }
    },
    percentage: {
      novalidate: true,
      'data-sparta-input-mask': {
        showMaskOnFocus: true,
        alias: 'percentage',
        allowMinus: true,
        digitsOptional: true
      }
    },
    'interest-rate': {
      novalidate: true,
      'data-sparta-input-mask': {
        showMaskOnFocus: true,
        alias: 'percentage',
        digits: 2,
        digitsOptional: true,
        rightAlign: false
      }
    }
  };
  var inputMaskDefaults = {
    greedy: true,
    placeholder: '',
    clearMaskOnLostFocus: true,
    showMaskOnHover: false,
    showMaskOnFocus: true,
    keepStatic: true,
    jitMasking: true,
    showTooltip: false,
    inputEventOnly: true
  };
  var maskAttributes = Object.assign({}, defaultFormatAttributes['data-sparta-input-mask'], formatAttributes[format] ? formatAttributes[format]['data-sparta-input-mask'] : {}, mask);
  var attributes = Object.assign({}, defaultFormatAttributes, formatAttributes[format] ? formatAttributes[format] : {}, inputAttributes, {
    'data-sparta-input-mask': maskAttributes
  });
  var defaultInputType = '';
  var mobileInputType = '';
  var androidInputType = '';
  var defaultPattern = '';
  var mobilePattern = '';
  reservedAttrs.forEach(function (key) {
    if (attributes[key]) {
      var attrs;
      switch (key) {
        case 'type':
          attrs = parseViewportDependentAttribute(attributes[key]);
          defaultInputType = attrs.defaultAttr;
          mobileInputType = attrs.mobileAttr;
          androidInputType = attrs.androidAttr;
          break;
        case 'pattern':
          attrs = parseViewportDependentAttribute(attributes[key]);
          defaultPattern = attrs.defaultAttr;
          mobilePattern = attrs.mobileAttr;
          break;
      }
      attributes[key] = undefined;
    }
  });
  Object.keys(attributes).forEach(function (key) {
    if (typeof attributes[key] !== 'undefined') {
      if (key !== 'disabled' || key === 'disabled' && attributes[key] !== false) {
        if (typeof attributes[key] !== 'string' && !(attributes[key] instanceof RegExp)) {
          attrsStr.push("".concat(key, "='").concat(key === 'data-sparta-input-mask' ? JSON.stringify(Object.assign({}, inputMaskDefaults, attributes[key])) : JSON.stringify(attributes[key]), "'"));
        } else if (attributes[key] !== '') {
          attrsStr.push("".concat(key, "=\"").concat(attributes[key], "\""));
        }
      }
    }
  });
  var inputHelpTrigger = '';
  var inputHelpContainerOpen = '';
  var inputHelpContainerClose = '';
  var inputHelpClose = '';
  var inputHelpBody = '';
  var inputContainerOpen = "<div class=\"\n    spa-input spa-input-box spa-input--".concat(inputData.skin ? inputData.skin : 'sparta2', "\n    ").concat(inputData.containerClasses ? " ".concat(inputData.containerClasses.join(' ')) : '', "\n    ").concat(inputData.input.attrs['data-help-body'] ? ' has-help' : '', "\n  \">");
  var inputContainerClose = '</div>';
  var inputLabelRequiredSpan = function inputLabelRequiredSpan(required) {
    // if required show asterisk
    if (!required) {
      return '';
    }
    var asteriskMark = '<span class="spa-input-label--asterisk">&nbsp;*</span>';
    return asteriskMark;
  };
  var labelModifiers = [];
  inputData.input.attrs['disabled'] ? labelModifiers.push('spa-input-label--disabled') : labelModifiers.push('spa-input-label');
  var inputLabel = "<label class=\"".concat(labelModifiers.join(' '), "\" for=\"").concat(inputData.input.attrs.id, "\">\n    ").concat(inputData.label.text).concat(inputLabelRequiredSpan(inputData.required, inputData.asterisk), "\n    <span class='ada-hidden'>\n      ").concat(inputData.currency ? "<span class='spa-input-text-currency-ada'>Enter ".concat(inputData.currency, " amount.</span>") : '', "\n      ").concat(inputData.label.adaText ? inputData.label.adaText : '', "\n    </span>\n  </label>");
  var inputField = "<input type=\"".concat(defaultInputType || 'text', "\" aria-describedby=\"").concat(inputData.input.attrs.id, "_errorMessage ").concat(inputData.input.attrs.id, "-hint-text\"") + "".concat(data.vueOptionsStr || '') + "".concat(defaultPattern ? "pattern=\"".concat(defaultPattern, "\"") : '') + "".concat(mobileInputType ? " data-mobile-input-type=\"".concat(mobileInputType, "\" data-default-input-type=\"").concat(defaultInputType, "\"") : '') + "".concat(androidInputType ? " data-android-input-type=\"".concat(androidInputType, "\"") : '') + "".concat(typeof mobilePattern !== 'undefined' ? " data-mobile-pattern=\"".concat(mobilePattern, "\" data-default-pattern=\"").concat(defaultPattern, "\"") : '') + "".concat(attrsStr.join(' ')) + "".concat(validationRules ? " data-validation-rules='".concat(JSON.stringify(validationRules).replace(/'/g, '&#39;'), "'") : '') + "".concat(inputData.required ? " required aria-required=\"true\" ".concat(typeof inputData.required === 'string' ? "data-required-error-message=\"".concat(inputData.required, "\"") : '') : '') + "".concat(inputData.currency ? 'aria-invalid="false"' : '') + "".concat(inputData.disabled ? ' disabled aria-disabled="true"' : '') + '/>';
  if (inputData.currency) {
    inputField = "<span aria-hidden=\"true\" class=\"spa-input-prefix--currency\" data-currency-value=\"".concat(inputData.currency, "\">").concat(inputData.currency, "</span>").concat(inputField);
  }
  var inputHint = "<p id=\"".concat(inputData.input.attrs.id, "-hint-text\" class=\"spa-input-hint\">").concat(inputData.hintText ? inputData.hintText : '', "</p>");
  var inputError = "<div class=\"spa-input-error-message spa-icon--error\" id=\"".concat(inputData.input.attrs.id, "_errorMessage\" aria-hidden=\"true\"></div>");
  if (inputData.input.attrs['data-help-body']) {
    // Add a help pop-up trigger, either a question mark or some link text.
    var triggerText = inputData.input.attrs['data-help-link'] || '';
    var triggerClass = triggerText ? 'toggle-trigger-link' : 'toggle-trigger svg-button form-help';
    inputHelpTrigger = button({
      content: triggerText || '&#160;',
      classes: "".concat(triggerClass, " spa-btn--link"),
      attributes: {
        id: "help-open-".concat(inputData.input.attrs.id),
        "aria-label": helpToggle
      }
    });
    if (!triggerText) {
      inputHelpTrigger = "<span class=\"toggle-trigger-box\">".concat(inputHelpTrigger, "</span>");
    }
    if (inputData.input.helpTriggerLink) {
      inputHelpTrigger = inputData.input.helpTriggerLink;
    }
    inputHelpContainerOpen = "<div class=\"input-help\" id=\"helpLayer_".concat(inputData.input.attrs.id, "\" role=\"tooltip\" aria-hidden=\"true\">");
    inputHelpContainerClose = '</div>';
    inputHelpClose = button({
      content: '&#160;',
      classes: "close-trigger svg-button",
      attributes: {
        id: "help-close-".concat(inputData.input.attrs.id),
        "aria-label": helpToggle
      }
    });
    inputHelpBody = "<div class=\"body\">".concat(inputData.input.attrs['data-help-body'], "</div>");
    if (inputData.input.attrs['data-help-head']) {
      // NEW HELIX changes
      // ---------------------------------
      // inputHelpBody = '<div class="head" data-font="cnx-bold">' +
      inputHelpBody = '<div class="head">' + "".concat(inputData.input.attrs['data-help-head']) + '</div>' + "".concat(inputHelpBody);
      // ---------------------------------
    }
  }

  // concatenating because line breaks can mess up the rendering of the html
  var inputElement = "".concat(inputContainerOpen) + "".concat(inputLabel) + "".concat(inputField) + "".concat(inputHelpTrigger) + "".concat(inputHint) + "".concat(inputHelpContainerOpen) + "".concat(inputHelpClose) + "".concat(inputHelpBody) + "".concat(inputHelpContainerClose) + "".concat(inputError) + "".concat(inputContainerClose);
  return new Handlebars.SafeString(inputElement);
}
var defaultInputType = 'text';
var defaultAttributes = {
  type: defaultInputType,
  class: 'spa-input-text',
  value: '',
  autocomplete: 'off',
  'data-gis-mask': false,
  'data-help-link': '',
  'data-help-head': '',
  'data-help-body': ''
};
var textInputConfig = new InputConfig();
var dateInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'date'
  },
  inputMode: 'date',
  pattern: '^(0[1-9]|1[012])\\/(0[1-9]|[12]\\d|3[01])\\/\\d{4}$'
});
var monthYearDateConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'month'
  }
});
var ssnInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel'
  },
  inputMode: 'numeric',
  pattern: '^\\d{3}-\\d{2}-\\d{4}$'
});
var einInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel'
  },
  inputMode: 'numeric',
  pattern: '^\\d{2}-\\d{7}$'
});
var emailInputConfig = new InputConfig({
  type: 'email'
});
var phoneInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel'
  },
  inputMode: 'numeric',
  pattern: '^\\d{3}-\\d{3}-\\d{4}$',
  maxlength: 12
});
var phoneExtendedInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel'
  },
  inputMode: 'numeric',
  pattern: '^\\d{3}-\\d{3}-\\d{4}\\sx\\d{4}$',
  maxlength: 18
});
var passwordInputConfig = new InputConfig({
  type: 'password'
});
var zipInputConfig = new InputConfig({
  pattern: '^\\d{5}$',
  type: {
    default: 'text',
    mobile: 'number',
    android: 'tel'
  },
  maxlength: 5
});
var zipExtendedInputConfig = new InputConfig({
  pattern: '^\\d{5}(-\\d{4})?$',
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel'
  },
  maxlength: 10
});
var numericInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'number'
  },
  pattern: '\\d*',
  inputMode: 'numeric'
});
var currencyInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel'
  },
  pattern: '^(([1-9]\\d{0,2}(,\\d{3})*)|0)(\\.\\d{1,2})?$',
  inputMode: 'numeric'
});
var currencyIntegerInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel'
  },
  pattern: '^(([1-9]\\d{0,2}(,\\d{3})*)|0)$',
  inputMode: 'numeric'
});
var interestRateInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel'
  },
  pattern: '^([1-9]\\d{0,2}(,\\d{3})*)(\\.\\d{1,2})?%$',
  inputMode: 'numeric'
});
var ccInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel'
  },
  pattern: '^\\d{4}(-\\d{4}){3}$',
  inputMode: 'numeric'
});
function textInput(data) {
  if (data.input.format === 'date') {
    return formatTextInput(data, dateInputConfig);
  }
  if (data.input.format === 'month-year-date') {
    return formatTextInput(data, monthYearDateConfig);
  }
  if (data.input.format === 'ssn') {
    return formatTextInput(data, ssnInputConfig);
  }
  if (data.input.format === 'ein') {
    return formatTextInput(data, einInputConfig);
  }
  if (data.input.format === 'cc-number') {
    return formatTextInput(data, ccInputConfig);
  }
  return formatTextInput(data, textInputConfig);
}
function emailInput(data) {
  return formatTextInput(data, emailInputConfig);
}
function phoneInput(data) {
  if (data.input.format === 'phone-extended') {
    return formatTextInput(data, phoneExtendedInputConfig);
  }
  return formatTextInput(data, phoneInputConfig);
}
function passwordInput(data) {
  return formatTextInput(data, passwordInputConfig);
}
function numericInput(data) {
  if (data.input.format === 'zip') {
    return formatTextInput(data, zipInputConfig);
  }
  if (data.input.format === 'zip-extended') {
    return formatTextInput(data, zipExtendedInputConfig);
  }
  return formatTextInput(data, numericInputConfig);
}
function interestRateInput(data) {
  return formatTextInput(data, interestRateInputConfig);
}
function currencyInput(data) {
  if (data.input.format === 'currency-integer') {
    return formatTextInput(data, currencyIntegerInputConfig);
  }
  return formatTextInput(data, currencyInputConfig);
}
function numberInput(data) {
  return new Handlebars.SafeString('<b><i>The "numberInput" helper is not supported in SPARTA 2.0 - it has been replaced by the "numericInput" helper</i></b>');
}
function dateInput(data) {
  return new Handlebars.SafeString('<b><i>The "dateInput" helper is not supported in SPARTA 2.0 - you should use the "numericInput" helper with the appropriate validation rules applied</i></b>');
}
function percentInput(data) {
  return new Handlebars.SafeString('<b><i>The "percentInput" helper is not supported in SPARTA 2.0 - you should use the "numericInput" helper with the appropriate validation rules applied</i></b>');
}
function internalAccountNumberInput(data) {
  return new Handlebars.SafeString('<b><i>The "internalAccountNumberInput" helper is not supported in SPARTA 2.0 - you should use the "numericInput" helper with the appropriate validation rules applied</i></b>');
}
function externalAccountNumberInput(data) {
  return new Handlebars.SafeString('<b><i>The "externalAccountNumberInput" helper is not supported in SPARTA 2.0 - you should use the "numericInput" helper with the appropriate validation rules applied</i></b>');
}
function ssnInput(data) {
  return new Handlebars.SafeString('<b><i>The "ssnInput" helper is not supported in SPARTA 2.0 - you should use the "numericInput" helper with the appropriate validation rules applied</i></b>');
}
function zipInput(data) {
  return new Handlebars.SafeString('<b><i>The "zipInput" helper is not supported in SPARTA 2.0 - you should use the "numericInput" helper with the appropriate validation rules applied</i></b>');
}

//Below code will set the spaParams in this singleton instance for site or widget based on where it is loaded from
try {
  if (typeof document !== 'undefined') {
    if (document.currentScript) {
      var widgetName = document.currentScript.getAttribute("widget-name");
      var widgetVersion = document.currentScript.getAttribute("widget-version");
      if (widgetName && widgetVersion) {
        localSpaParams = Object.assign(window.spaWidgetParams[widgetName][widgetVersion], {
          isWidget: true,
          language: document.currentScript.parentElement.querySelector('.sparta-widget-container').getAttribute('data-sparta-lang').split('-')[0]
        });
      } else {
        localSpaParams = window.spaParams;
      }
    } else {
      localSpaParams = window.spaParams;
    }
  }
} catch (e) {
  console.error('SpartaTextInputHelper: Failed to process localSpaParams');
}
export { currencyInput, dateInput, emailInput, externalAccountNumberInput, interestRateInput, internalAccountNumberInput, numberInput, numericInput, passwordInput, percentInput, phoneInput, ssnInput, textInput, zipInput };